import React from 'react';
import { CommandLineTools } from '../../components';
import s from './HostStyles.module.scss';

const CommandLineToolsHost = () => (
    <div className={s.editor} style={{ padding: '100px' }}>
        <CommandLineTools
            onFixBadgesAndLogos={(event, badgeScale) => console.log('fixBadgesAndLogos', badgeScale)}
            onPixifySvgs={() => console.log('pixifySvgs')}
            onValidateAiJson={() => console.log('validateAiJson')}
            onPrettyPrintAiJson={() => console.log('prettyPrintAiJson')}
        />
    </div>
);

export default CommandLineToolsHost;
